import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BsModalRef } from "ngx-bootstrap/modal";
import { WarningModalService } from "../../services/warning-modal/warning-modal.service";
import { AbstractModalComponent } from "../abstract-modal/abstract-modal.component"
import { ConstantsService } from "../../services/constants/constants.service";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-org-details-modal',
  templateUrl: './org-details-modal.component.pug',
  styleUrls: ['./org-details-modal.component.scss'],
  standalone: false
})
export class OrgDetailsModalComponent extends AbstractModalComponent implements OnInit {

  @Input() num_staff!: string;
  @Input() org_size!: string;
  @Input() industry!: string;
  @ViewChild('orgForm', { static: false }) orgForm: any;
  orgDetails: any;
  showValidationError = false;
  NUM_STAFF_CHOICES = ConstantsService.NUM_STAFF_CHOICES;
  ORG_SIZE_CHOICES = ConstantsService.ORG_SIZE_CHOICES
  INDUSTRIES = ConstantsService.INDUSTRIES;
  constructor(public _bsModalRef: BsModalRef, public modal: WarningModalService, public permissions: PermissionsService) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    this.orgDetails = {'org_size': this.org_size, 'industry': this.industry};
    this.INDUSTRIES[0] = {'label': $localize`Advertising, Media & Entertainment`, 'value': 'Advertising, Media & Entertainment'};
  }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }

  save() {
    this.messages = [];
    this.showValidationError = true;
    if (!this.orgForm.valid) {
      return;
    }
    this.event.emit(this.orgDetails);
  }

  getForm() {
    return this.orgForm;
  }

}
